import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from "./environments/environment";

if (environment.PRODUCTION) {
  Sentry.init({
      dsn: "https://cb7ca9d8e8c5068d5e90739ac97c9e2a@o4509368713150464.ingest.us.sentry.io/4509753302712320",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: .25,
      tunnel: environment.APP_URI + "/api/site/sentry/",
  })
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));